import React, {FC, useMemo} from 'react';

import {useAppSelector} from '../../helpers/reduxHelpers';
import {AppState} from '../../store/appState';
import {makeGetAppPanel} from '../../store/panels/app/appPanelSelectors';
import {AppContentTypesEnum} from '../../store/panels/app/parameters/appParameters';
import {AppPanelId} from '../../store/panels/panelStateBase';
import {GrammarlyButtonHost} from './grammarlyButtonHost';

/*
 * Props.
 */

interface AppGrammarlyButtonHostProps {
  panelId: AppPanelId;
}

/*
 * Component.
 */

export const AppGrammarlyButtonHost: FC<AppGrammarlyButtonHostProps> = (props) => {
  const {panelId} = props;
  const getAppPanel = useMemo(() => makeGetAppPanel(), []);
  const appPanel = useAppSelector((state: AppState) => getAppPanel(state, {panelId}));
  const isInInboxes = appPanel.contentType === AppContentTypesEnum.INBOXES;

  // Don't show the button when the user isn't in their inboxes
  if (!isInInboxes) {
    return null;
  }
  return <GrammarlyButtonHost shouldUseBottom shouldUseRight />;
};
